import { mensagemDoErro } from '../api';
import { ROTULO_PERFIL, dataCurta, plural } from '../format';
import { useApi } from '../hooks';
import { Icone } from '../icones';
import { encerrarInspecao } from '../session';
import { usuario } from '../state';
import { Carregando, ErroForm } from '../ui';
import type { PesquisaAberta } from '../coleta/Formulario';

/** Faixa fixa no topo enquanto um administrador inspeciona a conta de outra pessoa. Impossível de esquecer ligada. */
export function FaixaInspecao() {
  const u = usuario.value;
  if (!u?.inspecionadoPor) return null;
  return (
    <div class="faixa-inspecao" role="status">
      <Icone nome="inspecionar" tamanho={18} />
      <span>
        Inspecionando <strong>{u.nome}</strong> ({ROTULO_PERFIL[u.perfil]}) · somente leitura
      </span>
      <button type="button" class="faixa-sair" onClick={() => void encerrarInspecao()}>
        Sair da inspeção
      </button>
    </div>
  );
}

/**
 * O pesquisador trabalha no app de campo (celular, com fila no aparelho). Inspecioná-lo NÃO abre esse app: ele mexeria na fila
 * deste aparelho. Mostra, só para leitura, o que o pesquisador enxerga: as pesquisas abertas, os municípios e o progresso.
 */
export function PesquisadorInspecionado() {
  const abertas = useApi<PesquisaAberta[]>('/pesquisas/abertas');
  return (
    <main class="pagina">
      <header class="pagina-topo">
        <div>
          <h1>Visão do pesquisador</h1>
          <p class="dica">O pesquisador usa o app de campo no celular. Aqui você vê o que ele vê: as pesquisas abertas e o andamento em cada município.</p>
        </div>
      </header>
      {abertas.erro && <ErroForm texto={mensagemDoErro(abertas.erro)} />}
      {abertas.carregando && !abertas.dados && <Carregando />}
      {abertas.dados?.length === 0 && <p class="vazio-grande">Nenhuma pesquisa aberta para este pesquisador agora.</p>}
      {(abertas.dados ?? []).map((p) => (
        <section class="cartao" key={p.id}>
          <h2>{p.titulo}</h2>
          <p class="dica">Coleta de {dataCurta(p.periodoInicio, true)} até {dataCurta(p.periodoFim, true)}</p>
          <ul class="lista-periodos">
            {p.municipios.map((m) => (
              <li key={m.codIbge}>
                <span>
                  <strong>{m.nome}</strong>
                  <small class="sub">{plural(m.coletadasPorMim, 'resposta dele', 'respostas dele')} · {m.coletadasNoMunicipio} de {m.meta} no município</small>
                </span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </main>
  );
}
